var $export   = require('./_export')
  , $parseInt = require('./_parse-int');
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});


/** WEBPACK FOOTER **
 ** ./~/babel-polyfill/~/core-js/modules/es6.parse-int.js
 **/